import Seo from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { Blocks } from "../components/site/Blocks";
import { Faq } from "../components/site/Faq";
import { QuoteSection } from "../components/site/QuoteSection";
import { CtaBand } from "../components/site/CtaBand";
import { Marquee } from "../components/site/Marquee";
import { TermiteLinks } from "../components/site/TermiteLinks";
import { PROMISES } from "../data/site";

export default function ContentPage({ page, zoneName }) {
  return (
    <main data-testid={`page-${page.path.split("/").pop()}`}>
      <Seo title={page.seo.title} description={page.seo.description} path={page.path} faq={page.faq} breadcrumb={page.breadcrumb} service={page.service} article={page.article} image={page.hero?.image} />
      <PageHero hero={page.hero} breadcrumb={page.breadcrumb} />
      <div className="mt-10"><Marquee items={PROMISES} speed={22} /></div>
      <Blocks blocks={page.blocks} />
      <QuoteSection zone={zoneName} />
      <Faq items={page.faq} title={zoneName ? `Questions fréquentes — ${zoneName}` : "Questions fréquentes"} />
      <TermiteLinks zone={page.zoneSlug} place={zoneName} />
      <CtaBand />
    </main>
  );
}
